module.exports = __webpack_public_path__ + "static/media/2.12.abc26adf.png";